import { DEFAULT_MEDIA_DURATION, PROJECT_MEDIA_TYPES } from 'consts'
import { IAIImageProject } from 'store/types/aiImage'
import { IVersionHistoryItem } from 'store/types/aiVideo'
import { IBaseMediaItem } from 'types/media'

export const convertAiImgToBaseMediaItem = (
  item: IAIImageProject
): IBaseMediaItem => {
  const image = item.images[0]
  const { width, height } = item
  const { filePath, id } = image
  const assetParentId = item.id.toString()

  return {
    path: filePath,
    type: PROJECT_MEDIA_TYPES.aiImage,
    originalWidth: width,
    originalHeight: height,
    duration: DEFAULT_MEDIA_DURATION,
    fileName: `ai-image-${id}`,
    assetId: id.toString(),
    assetParentId
  }
}
export const convertHistoryVersionImgToBaseMediaItem = (
  item: IVersionHistoryItem
) => {
  return {
    path: item.url,
    type: PROJECT_MEDIA_TYPES.aiImage,
    originalWidth: item.width ?? 0,
    originalHeight: item.height ?? 0,
    duration: DEFAULT_MEDIA_DURATION,
    fileName: `ai-image-${item.assetId}`,
    assetId: String(item.assetId),
    assetParentId: item.id.toString(),
    thumbnail: item.thumbnailUrl
  }
}
